import React from 'react';
import { Field } from 'redux-form'
import FloatingActionButton from 'material-ui/FloatingActionButton';
import ContentAdd from 'material-ui/svg-icons/content/add';
import MenuItem from 'material-ui/MenuItem';

import FormAutoComplete2 from './FormAutoComplete2'
import FormSelect from './FormSelect'
import FormText from './FormText'

import * as colors from 'material-ui/styles/colors';

import * as commons from '../commons';
import moment from "moment";

class FormClaimAmmounts extends  React.Component {

  render() {

    const {
      fields,
      status,
      auth
    } = this.props

    const year = moment().format("YYYY");

    const yearList = []
    for (let i = Number(year) - 5; i < Number(year) + 6; i++) {
      yearList.push(i)
    }

    return (

      <div>

        {fields.map((name, index) => {
          return (
            <div className="row" key={index}>

              <div className="col-3">
                <Field
                    name={`${name}.year`}
                    component={FormSelect}
                    style={{ width: '100%' }}
                    label="年"
                    disabled={status === 3}
                >
                  {
                    yearList && yearList.map((x, index) => {
                      return (<MenuItem key={index} value={x} primaryText={x} />)
                    })
                  }
                </Field>
              </div>
              <div className="col-3">
                <Field
                    name={`${name}.month`}
                    component={FormSelect}
                    style={{ width: '100%' }}
                    label="月"
                    disabled={status === 3}
                >
                  {
                    [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12].map((x, index) => {
                      return (<MenuItem key={index} value={x} primaryText={x} />)
                    })
                  }
                </Field>
              </div>

              <div className="col-3">
                <Field name={`${name}.claimAmmount`} component={FormText} label="請求金額" style={{ width: '100%' }} format={commons.dispMoney} normalize={commons.dispMoney} disabled={status === 3} />
              </div>
              <div className="col-3">
                <Field name={`${name}.claimComment`} component={FormText} label="備考" style={{ width: '100%' }} disabled={status === 3} />
              </div>
            </div>
          )
        })}

        <div className="row">
          <div className="col-12" style={{ display: 'flex', justifyContent: 'flex-end', marginTop: 10 }}>
            <FloatingActionButton zDepth={0} mini={true} backgroundColor={colors.grey400} disabled={status === 3}
              onClick={() => {
                fields.push({})
              }}>
              <ContentAdd />
            </FloatingActionButton>
          </div>
        </div>

      </div>

    )

  }

}

export default FormClaimAmmounts


// WEBPACK FOOTER //
// ./src/components/FormClaimAmmounts.js